import http from '@root/utils/axios/admin';

let state = {
    NewsList: [],
    New: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchNewsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/news', { params: filter }).then((response) => {
                commit('setNewsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteNew({ commit }, id) {
        return http.delete('user/news/' + id);
    },

    fetchNew({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('user/news/' + id).then((response) => {
                commit('setNew', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateNew({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/news', data).then((response) => {
                commit('setNew', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setNewError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateNew({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/news/' + data.get('id'), data).then((response) => {
                commit('setNew', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setNewError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setNewsList(state, data) {
        state.NewsList = data;
    },
    setNew(state, data) {
        state.New.data = data;
    },
    setNewError(state, error) {

        state.New.error = error.errors;
    },
    cleanNewError(state, error) {
        state.New.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}